import Cookie from "cookie-universal";
const cookies = Cookie();
export default cookies;
